export default "__VITE_ASSET__DcvJMUrO__"